import axios from './index'
const origin = '/co/point/'

const getData = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'LoadPointList', param).then(res => resolve(res))
    })
}
// const getDetail = (id) => {
//     return new Promise(resolve => {
//         axios.post(origin + 'LookPoint', id).then(res => resolve(res))
//     })
// }
//获取项目(景点就是项目)
const listPoints = () => {
    return new Promise(resolve => {
        axios.post(origin + 'ListPoint').then(res => resolve(res))
    })
}

const addPoint = (param) => {
    return new Promise(resolve => {
        axios.post(origin + 'AddPoint', param).then(res => resolve(res))
    })
}
//修改景点
const updatePoint = param => {
    return new Promise(resolve => {
        axios.post(origin + 'UpdatePoint', param).then(res => resolve(res))
    })
}
//
const enablePoint = param => {
    return new Promise(resolve => {
        axios.post(origin + 'EnablePoint', param).then(res => resolve(res))
    })
}
const disablePoint = param => {
    return new Promise(resolve => {
        axios.post(origin + 'DisablePoint', param).then(res => resolve(res))
    })
}
const deletePoint = param => {
    return new Promise(resolve => {
        axios.post(origin + 'DeletePoint', param).then(res => resolve(res))
    })
}
export default {
    getData,
    // getDetail,
    listPoints,
    addPoint,
    updatePoint,
    enablePoint,
    disablePoint,
    deletePoint
}